import { useAppDispatch } from "../../../redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  getSurveyReport,
  updatePageIndex,
} from "../../../redux/reducer/surveyReportReducer";
import Row from "./Row";
import TableHeader from "./tableHeader";
import Pagination from "../../pagination";
import { Spinner } from "react-bootstrap";

const SurveyFilterTable = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  /**
   * Get state variables from redux store.
   */
  const { surveysReport } = useSelector((state: any) => state);
  const { surveysReportList, pageIndex, pageTotal } = surveysReport;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      await dispatch(getSurveyReport());
    } finally {
      setLoading(false);
    }
  };


  /**
   * update survey report table pagination and refetch on page change.
   */
  const setPageIndex = (newpage: any) => {
    dispatch(updatePageIndex(newpage));
    dispatch(getSurveyReport());
  };

  return (
    <div className="container-box mb-3">
      <div className="content pt-0">
        <table className="table">
          <TableHeader />
          <tbody>
            {!loading && surveysReportList.map((report: any, key: any) => (
              <Row report={report} key={key} />
            ))}
          </tbody>
        </table>
        <div className="col-12 mt-2 mb-2">
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                size="sm"
                className="ms-2 spinner-size"
              />
            </div>
          ) : (
            <Pagination
              onPageChange={setPageIndex}
              pageIndex={pageIndex}
              pageTotal={pageTotal}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SurveyFilterTable;
